export { default } from "./TeacherPreview";
